<template>
  <jc-page>
    <view class="list u-skeleton">
      <!-- 下拉刷新组件 -->
      <z-paging ref="paging" class="mar-tabbar" v-model="dataList" @query="queryList"
                empty-view-img="http://175.19.30.69:2490/qcykshop/swapp/icon/newImg003_03.jpg" 
                :empty-view-img-style="{
					width: '362rpx',
					height: '330rpx',
			    }">
        <!-- 顶部导航区域 -->
        <template v-slot:top>
          <uni-nav-bar leftIcon="" :title="title" :border="false" statusBar :color="vuex_fontColor" :backgroundColor="vuex_backgroundColor"></uni-nav-bar>
          <!-- <view class="stop u-flex">
            <view class="u-flex-11" style="margin:10px 2%;">
              <up-search
                  ref="searchBar"
                  class="searchBar"
                  v-model="searchText"
                  @search="searchConfirm"
                  @custom="searchConfirm"
                  @clear="searchConfirm"
                  @blur="searchConfirm"
				  @focus="toSearch"
                  placeholder="请输入搜索内容"
                  borderColor="#909399"
                  bgColor="#ffffff"
                  :animation="false"
                  ></up-search>
            </view>
          </view> -->
		  <view class="_w100 f_c_c_c" style="padding: 10rpx 0;">
			  <view class="input_con f_r_c_sb" style="width: 95%;" @click='toSearch'>
				  <view class="f_r_c_c">
					  <image class="search_icon" style="margin-left: 10rpx;" :src="fnStaticRequestPath('icon/search_prod.png')" ></image>
					  	<input 
					  		class="auto_input" 
					  		type='text' 
					  		v-model="searchText"
					  		style="margin-left: 10rpx;"
					  		placeholder='请输入搜索内容' 
					  		@confirm="toSearch" 
					  	></input>
				  </view>
			  	
			  	  <!-- <up-button class="search_btn" :style="{'background-color':vuex_skinColor}" @click='toSearch'>搜索</up-button> -->
				  <view class="search_btn f_c_c_c" :style="{'background-color':vuex_skinColor}" @click='toSearch'>搜索</view>
			  </view>
		  </view>
		  
          <!-- 分类tab -->
          <view class="stop">
            <up-tabs :list="classifyTabList" :current="classifyCurrentTab" @click="tabsClick"></up-tabs>
          </view>
          <!-- 排序选项 -->
          <view class="stop">
            <jc-orderby :optionlist="optionlist" @change="changeOption"></jc-orderby>
          </view>
        </template>

        <view class="goods-list">
          <view class="goods-item" v-for="(item, index) in dataList" :key="index" @click="goProdDetail(item)">
            <u-image class="goods-image" width="100%" height="170px" radius="5px" :src="fnImgRequestPath(item.mainLagerImgUrl)" mode="aspectFill" ></u-image>
            <view class="goods-title">
              {{item.prodName}}
            </view>
            <view class="goods-price f_r_c_s" style="align-items: baseline;"  v-if="membType == 1">
              <view class="f_r_e_s" style="align-items: baseline !important;">
				  <view style="font-size: 24rpx;">￥</view>
				   <view>{{item.minPrice}}</view>
			  </view>
              <view style="margin-left: 16rpx;" :class="membType == 1 ? 'goods-price-original' : ''">￥{{item.minUdValue}}</view>
            </view>
			<view class="goods-price f_r_c_s" style="align-items: baseline;"  v-else>
			  <view class="f_r_e_s" style="align-items: baseline !important;">
				  <view style="font-size: 24rpx;">￥</view>
				   <view>{{item.minUdValue}}</view>
			  </view>
			</view>

            <view class="goods-add" @click.stop="showDialog(item)">
				<u-icon name="jiahao2fill" custom-prefix="custom-icon"  size="50rpx" :color="vuex_skinColor" ></u-icon>
            </view>
          </view>
        </view>
		
      </z-paging>
    </view>
    <!-- 选择sku -->
    <GoodsSelectSpec :membType="membType" :show="isShowSelectSpec"  :data="prodInfo" :selectedSku="prodSingleProductBo" @fnClose="fnClose" @bugNowHandle="bugNowHandle" @changeSku="changeSku" @changeNum="changeNum"></GoodsSelectSpec>

  </jc-page>
</template>

<script setup>
import { onLoad, onShow } from '@dcloudio/uni-app'
import { getCurrentInstance, reactive, ref } from "vue"
import GoodsSelectSpec from '@/pages/prodDetail/goods-select-spec.vue';// 商品规格选择
import {
  selectProdInfoPageApi,
  getProdInfoApi,
  selProdClassifyInfoTwoApi,
  checkOutMembInfoApi,
  checkStockNumApi,
  getMembInfoByIdApi,
  getBaseSystemSetInfoByPlatIdApi
} from '@/api/prod/prod'
import {fnImgRequestPath,fnStaticRequestPath} from "@/utils/utils";
const { ctx } = getCurrentInstance()
// 定义可以触发的事件
const emit = defineEmits(['fnDealCartNum'])
// 获取环境变量
const imgPrefixUrl = import.meta.env.VITE_IMG_PREFIX_URL

// 页面数据
const title = ref('商城')
const searchText = ref('') // 搜索内容
const paging = ref(null) // 分页组件
const dataList = ref([]) // 商品列表数据
const membType = ref(0) // 0 散客 1会员
const inSource = ref('') // 商品来源类型

// 分类tab数据
const classifyTabList = reactive([
  { name: '全部', classifyId: '' }
])
const classifyCurrentTab = ref(0) // 当前选中的tab索引
const classifyIdSel = ref(null) // 当前选中的分类id

// 排序相关
const sortType = ref(41) // 默认综合降序
const tab_bar = ref(0) // 当前选中的tab

// 排序选项
const optionlist = reactive([{
  name: '综合',
  value: 'composite',
  isAsc: false
}, {
  name: '销量',
  value: 'sales',
  isAsc: false
}, {
  name: '新品',
  value: 'nts',
  isAsc: false
}, {
  name: '价格',
  value: 'price',
  isAsc: false
}])
const isShowSelectSpec = ref(false)// 是否显示规格弹出层
const prodInfo = ref({}) // 商品信息
const prodName = ref('') // 商品名称
const prodSingleProductBos = ref([]) // 商品规格信息
const buyNum = ref(1) // 购买数量
const isLimitPurchase = ref(0) // 限购类型: 0无限制 1单次限购 2单天限购 3总限购
const limitPurchaseNum = ref(0) // 限购数量
const prodSingleProductBo = ref({label: '', num: 0, singleProdId: '', prodName:'', price: '', udValue: '', imgUrl: '', prodType: '', detailType: '', redisVirtualNum:'',specDispStr:''})// 选中规格详情
// 系统设置
const isDontSale = ref(0) // 是否禁售: 1开始禁售 0关闭

// 页面加载
onLoad((option) => {
  console.log("onLoad 我是shop")
  if (option && option.inSource) {
    inSource.value = option.inSource
    if (option.inSource === '001') {
      title.value = '悦享专区'
    } else if (option.inSource === '004') {
      title.value = '健康优库'
    }
  }
  // 初始化分类信息
  initClassify()
  // 获取系统设置
  getSystemSetInfo()
})
function fnClose(){
  isShowSelectSpec.value = false;
  emit('fnDealCartNum');
}
// 打开选择sku的弹窗
function openSkuPopup() {
  isShowSelectSpec.value = true;
}

function addShoppingCart(){
  openSkuPopup();
}

function buyNow(){
  openSkuPopup();
}

function bugNowHandle(){
  // 判断是否登录
  if (!ctx.vuex_hasLogin) {
    //不存在则跳转至登录页
    uni.reLaunch({
      url: "/pages/login/login",
      success: () => {
        plus.navigator.closeSplashscreen();
      }
    })
  }
  // 判断是否冻结
  checkoutUserInfo();
}
function checkoutUserInfo(){
  var param = {};
  param.membId = ctx.vuex_membid;
  checkOutMembInfoApi(JSON.stringify(param)).then(res => {
    if(res.retCode == 1){
      // 校验限购
      checkOutProd();
    }else{
      ctx.$u.toast(res.retMsg);
    }
  })
}

function changeNum(num){
  prodSingleProductBo.value.num = num;
}

function changeSku(prodSingleProductTemp){
  console.log("--------点击了变更规格",prodSingleProductTemp)
  let prodName = prodSingleProductTemp.prodBaseInfoBo.prodName;
  let num = prodSingleProductTemp.num;
  prodSingleProductBo.value = {
    label: prodSingleProductTemp.specDispStr,
    num: num,
    singleProdId : prodSingleProductTemp.singleProdId,
    prodName: prodName,
    price: prodSingleProductTemp.price,
    udValue: prodSingleProductTemp.udValue,
    imgUrl: fnImgRequestPath(prodSingleProductTemp.imgUrl),
	prodType: prodSingleProductTemp.prodType,
	detailType: prodSingleProductTemp.detailType,
	redisVirtualNum: prodSingleProductTemp.virtualNum,
	specDispStr: prodSingleProductTemp.specDispStr,
  }
  if(membType.value != 1){
  	prodSingleProductBo.value.price = prodSingleProductTemp.udValue;
  }
  console.log(prodSingleProductBo.value)
}

function getBuyProd(prodSingleProductBo){
  let orderProductDetailBo = {
    singleProdId: prodSingleProductBo.singleProdId,
    buyNum: prodSingleProductBo.buyNum,
    prodName: prodSingleProductBo.prodName,
    prodType: prodSingleProductBo.prodType,
    detailType: prodSingleProductBo.detailType==null||prodSingleProductBo.detailType=='' ? (prodSingleProductBo.isSuit == 0 ? 1 : 2) : prodSingleProductBo.detailType,
    isNew: 1,
    isGift: 0,//默认非赠品
    isFullfil: 0,//默认非满赠 
  };
  return orderProductDetailBo;
}
// 页面显示
onShow(() => {
  console.log("onShow 我是shop")
  // 如果是首页跳转过来的，获取输入框参数
  if(uni.getStorageSync("_parameterObj") != undefined && uni.getStorageSync("_parameterObj") != "") {
  	let _parameterObj = uni.getStorageSync("_parameterObj")
  	searchText.value = _parameterObj.parameter
  	uni.removeStorageSync("_parameterObj")
  }
  // 获取用户信息
  getMembInfo()
})
function checkOutProd(){
  if(isDontSale.value==1){
    ctx.$u.toast("暂未开放购买");
  }
  // 跳转到结算页
  let singleProductBo = prodSingleProductBos.value.filter(e=>e.singleProdId === prodSingleProductBo.value.singleProdId)[0];
  singleProductBo.prodName = prodSingleProductBo.value.prodName
  let buyProd = getBuyProd(singleProductBo)
  buyProd.buyNum = prodSingleProductBo.value.num;
  console.log("----------------跳转到结算页",JSON.stringify(buyProd))
  isShowSelectSpec.value = false
  uni.navigateTo({
    url: "../orderSettlement/orderSettlement?buyProd="+JSON.stringify(buyProd),
  });
}
/**
 * 模拟onShow方法
 */
function onHandleShow() {
  console.log("onHandleShow 我是shop")
}

// 将 onHandleShow 暴露给父组件
defineExpose({ onHandleShow });
// 初始化分类信息
function initClassify() {
  const params = {
    platId: 1,
    superClassifyId: '0',
    prodType: inSource.value || '004'
  }

  selProdClassifyInfoTwoApi(JSON.stringify(params)).then(res => {
    if (res.retCode == 1) {
      // 清空原有分类（除了"全部"）
      classifyTabList.splice(1)

      // 添加新分类
      res.objs.forEach(item => {
        classifyTabList.push({
          name: item.classifyName,
          classifyId: item.classifyId
        })
      })
    }
  }).catch(err => {
    console.error('获取分类信息失败:', err)
  })
}

// 获取系统设置信息
function getSystemSetInfo() {
  const params = {
    platId: 1
  }

  getBaseSystemSetInfoByPlatIdApi(JSON.stringify(params)).then(res => {
    if (res.retCode == 1) {
      isDontSale.value = res.obj.isDontSale || 0
    }
  }).catch(err => {
    console.error('获取系统设置失败:', err)
  })
}

// 获取用户信息
function getMembInfo() {
  const memb = uni.getStorageSync('lifeData').vuex_user
  if (memb) {
    membType.value = memb.membType || 0
	const membId = uni.getStorageSync('lifeData').vuex_user.membId
	if (membId) {
	  const params = {
	    membId: membId,
	    platId: 1
	  }
	
	  getMembInfoByIdApi(JSON.stringify(params)).then(res => {
	    if (res.retCode == 1) {
	      uni.setStorageSync('memb', res.obj)
	    }
	  }).catch(err => {
	    console.error('获取会员信息失败:', err)
	  })
	}
  }
  
}

// 商品分页查询方法
function queryList(pageNo, pageSize) {
  // 构造查询参数
  const params = {
    page: {
      pageNum: pageNo,
      pageSize: pageSize
    },
    prodName: searchText.value,
    sortType: sortType.value,
    // chiefGradeId: uni.getStorageSync('lifeData').vuex_user.memberGradeId,
    platId: 1,
    selProdType: '004'
  }
  if(uni.getStorageSync('lifeData') && uni.getStorageSync('lifeData').vuex_user){
	  params.chiefGradeId = uni.getStorageSync('lifeData').vuex_user.memberGradeId
  }

  // 添加分类筛选条件
  if (classifyIdSel.value) {
    params.classifyId = classifyIdSel.value
  }

  // 调用API获取商品列表
  selectProdInfoPageApi(JSON.stringify(params)).then(res => {
    if (res.retCode == 1) {
		if(params.chiefGradeId == null){
			res.objs.forEach(item=>{
				item.minUdValue = item.minPrice
				item.prodSingleProductBos.forEach(e =>{
					e.udValue = e.price
				})
			})
		}
      paging.value.completeByTotal(res.objs,res.page.total)
    } else {
      paging.value.complete(false)
    }
  }).catch(err => {
    console.error('获取商品列表失败:', err)
    paging.value.complete(false)
  })
}

// tab切换
function tabsClick(item) {
  classifyCurrentTab.value = item.index
  classifyIdSel.value = item.classifyId || null
  // 重新加载数据
  paging.value.reload()
}

// 排序切换
function changeOption(option) {
  // 根据选中的排序选项设置sortType
  switch(option.value) {
    case 'composite': // 综合
      sortType.value = option.isAsc ? 40 : 41
      break
    case 'sales': // 销量
      sortType.value = option.isAsc ? 20 : 21
      break
    case 'nts': // 新品
      sortType.value = option.isAsc ? 10 : 11
      break
    case 'price': // 价格
      sortType.value = option.isAsc ? 30 : 31
      break
    default:
      sortType.value = 41
  }

  // 重新加载数据
  paging.value.reload()
}

// 搜索方法
function searchClick() {
  uni.hideKeyboard()
  uni.navigateTo({
    url: '/pages/search/search',
    animationType: 'fade-in'
  })
}

// 搜索确认
function searchConfirm(val) {
	searchText.value = val
	paging.value.reload()
}

	/**
	 * 搜索跳转
	 */
	function toSearch() {
		uni.hideKeyboard()
		uni.navigateTo({
			url: '/pages/search/search?type=3&keyword='+searchText.value,
			animationType: 'fade-in',
			events: {
				// 定义一个事件，用于接收 B 页面传回的数据
				receiveDataFrom: (data) => {
					// console.log('A 页面接收到 B 页面的数据:', data)
					searchText.value = data.value // 更新输入框
					queryList()
				}
			}
		});
		ctx.$u.vuex('vuex_isSerarchBack', true);
	}

// 跳转到商品详情页
function goProdDetail(prod) {
  uni.navigateTo({
    url: "/pages/prodDetail/detail?prodId=" + prod.prodId
  })
}

// 显示规格选择弹窗
function showDialog(prod) {
  // 检查是否禁售
  if (isDontSale.value === 1) {
    uni.showToast({
      title: '暂未开放购买',
      icon: 'none'
    })
    return
  }
console.log(prod)
// if(!ctx.vuex_hasLogin){
// 	uni.showToast({
// 	  title: '请登录',
// 	  icon: 'none'
// 	})
// 	return
// }
  // // 检查用户登录状态
  // const membId = uni.getStorageSync('lifeData').vuex_user.membId
  // if (!membId) {
  //   // 跳转到登录页面
  //   uni.navigateTo({
  //     url: '/pages/login/login'
  //   })
  //   return
  // }

  prodInfo.value = prod
  prodName.value = prod.prodName
  prodSingleProductBos.value = prod.prodSingleProductBos || []

  // 默认选中第一个规格
  if (prodSingleProductBos.value.length > 0) {
    prodSingleProductBo.value ={
      label: prodSingleProductBos.value[0].specDispStr,
          num: 1,
          singleProdId : prodSingleProductBos.value[0].singleProdId,
          prodName: prodName,
          price: prodSingleProductBos.value[0].price,
          udValue: prodSingleProductBos.value[0].udValue,
          imgUrl: fnImgRequestPath(prodSingleProductBos.value[0].imgUrl),
		  prodType: prodSingleProductBos.value[0].prodType,
		  detailType: prodSingleProductBos.value[0].detailType,
		  redisVirtualNum: prodSingleProductBos.value[0].virtualNum,
		  specDispStr: prodSingleProductBos.value[0].specDispStr,
    }
	if(membType.value != 1){
		prodSingleProductBo.value.price = prodSingleProductBos.value[0].udValue;
	}
  }

  // 设置限购信息
  isLimitPurchase.value = prod.isLimitPurchase || 0
  limitPurchaseNum.value = prod.limitPurchaseNum || 0

  buyNum.value = 1
  isShowSelectSpec.value = true


}
// 检查限购
function checkLimitPurchase() {
  if (isLimitPurchase.value === 1 && buyNum.value > limitPurchaseNum.value) {
    buyNum.value = limitPurchaseNum.value
    uni.showToast({
      title: `单次购买限购数量：${limitPurchaseNum.value}`,
      icon: 'none'
    })
  }
}

// 添加到购物车
function addToCart() {
  uni.showToast({
    title: '已加入购物车',
    icon: 'success'
  })
  hideDialog()
}
</script>

<style lang="scss" scoped>
page {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #efeff4;
  min-height: 100%;
  height: auto;
}

.stop {
  background-color: #ffffff;
  height: 42px;
}

.goods-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10rpx 20rpx;
  // background-color: #f4f4f4;
}

.goods-item {
  width: calc(50% - 10rpx);
  background-color: #ffffff;
  border-radius: 10rpx;
  margin-bottom: 20rpx;
  position: relative;
  box-sizing: border-box;
  font-family: sans-serif;
  align-items: center;
}

.goods-item:nth-child(odd) {
  margin-right: 20rpx;
}

.goods-image {
  width: 100%;
  height: 165px;
  border-radius: 10rpx 10rpx 0 0;
}

.goods-title {
  font-size: 28rpx;
  color: #333;
  padding: 10rpx;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.goods-price {
  font-size: 20px;
  color: #f00;
  padding: 0 10rpx 10rpx;
  line-height: 36px;
}

.goods-price-original {
  font-size: 14px;
  color: #ccc;
  // margin-top: 15px;
  line-height: 36px;
  text-decoration: line-through;
}

.goods-add {
  position: absolute;
  bottom: 24rpx;
  right: 20rpx;
}

.mar-tabbar {
 margin-bottom: calc(100upx + env(safe-area-inset-bottom) / 2) !important;
}

.u-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.u-flex-11 {
  flex: 11;
}

.searchBar{
  margin-right: 15rpx !important;
  margin-left: 10rpx !important;
  margin-top: 10rpx !important;
}

.demo-warter {
  border-radius: 8px;
  margin: 10px 5px;
  background-color: #ffffff;
  position: relative;
}

.demo-image {
  width: 100%;
  border-radius: 4px;
}

.demo-title {
  font-size: 24rpx !important;
  margin-top: 5px;
  color: #333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  padding:0 10px;
  margin:10px 0;
  overflow: hidden;
}

.demo-tag {

  margin-top: 5px;

  bottom: 15px;
  right: 30px;
}

.demo-price {
  display: flex;
  justify-content: space-between; /* 关键属性：元素分散排列，两端对齐 */
  margin-left: 10px;
  /* 建议添加右外边距保持对称 */
  margin-right: 10px;
  font-size: 20px;
  color: #f00;
  margin-top: 5px;
  line-height: 36px;
  margin-left: 10px;
}

.demo-price-delete{
  font-size: 14px;
  color: #ccc;
  margin-top: 15px;
  line-height: 36px;
  text-decoration: line-through;
}

// 弹窗样式
.popup-content {
  padding: 20rpx;
}

.prod-info {
  display: flex;
  flex-direction: row;
  margin-bottom: 30rpx;
}

.prod-info-right {
  margin-left: 20rpx;
  flex: 1;
}

.prod-name {
  font-size: 28rpx;
  color: #333;
  margin-bottom: 10rpx;
}

.prod-price {
  font-size: 32rpx;
  color: #f00;
  font-weight: bold;
}

.spec-list {
  margin-bottom: 30rpx;
}

.spec-title {
  font-size: 28rpx;
  color: #333;
  margin-bottom: 20rpx;
}

.spec-item {
  display: flex;
  flex-wrap: wrap;
}

.spec-option {
  padding: 10rpx 20rpx;
  border: 1rpx solid #ddd;
  border-radius: 8rpx;
  margin-right: 20rpx;
  margin-bottom: 20rpx;
  font-size: 24rpx;
}

.spec-option.active {
  border-color: #3a8a79;
  color: #3a8a79;
}

.buy-num {
  margin-bottom: 30rpx;
}

.buy-num-title {
  font-size: 28rpx;
  color: #333;
  margin-bottom: 20rpx;
}

.popup-footer {
  padding: 20rpx 0;
}
.input_con {
		/* 使用Flex布局让输入框和按钮在同一行 */
		display: flex;
		/* 水平排列 */
		align-items: center;
		/* 垂直居中 */
		/* 容器样式模拟输入框外观 */
		border: 1px solid #ddd;
		border-radius: 100px;
		height: 70rpx;
		line-height: 68rpx;
		padding: 0 5px;
		background: #fff;
	}
	.search_icon {
		display: block;
		width: 20px;
		height: 20px;
		/* margin-top: 15rpx;
	  margin-right:0rpx;
	  margin-top: 3px; */
	}
	.search_btn {
		/* 按钮样式 */
		// max-width: 120rpx;
		// height: auto;
		align-items: center;
		/* 垂直居中 */
		// line-height: 58rpx;
		padding: 0 20rpx;
		color: white;
		border-radius: 28rpx;
		margin-right: -4rpx !important;
		// margin-top: 2rpx;
		// margin-bottom: 2rpx;
		font-size: 28rpx;
		/* 去除按钮默认样式 */
		// border: none;
		// outline: none;
		height: 90%;
		width: 110rpx;
	}
</style>